import { reportingErrorStatus } from 'src/queries/reporting/reporting.errors'

export { reportingErrorStatus }

export const newReportingIdempotencyKey = (): string =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `draft-${Date.now()}`

export const reportingErrorCode = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') return undefined
  const response = (
    error as {
      response?: {
        status?: number
        data?: { code?: unknown; detail?: unknown }
      }
    }
  ).response
  if (
    response?.status === 409 &&
    response.data?.detail === 'conversation_run_active'
  ) {
    return 'conversation_run_active'
  }
  return typeof response?.data?.code === 'string'
    ? response.data.code
    : undefined
}

export const isReportingAccessDenied = (error: unknown): boolean => {
  const status = reportingErrorStatus(error)
  return status === 403 || status === 404
}

export const isReportingTransientError = (error: unknown): boolean =>
  reportingErrorStatus(error) === 503

export const isReportingIdempotencyConflict = (error: unknown): boolean =>
  reportingErrorStatus(error) === 409 &&
  reportingErrorCode(error) !== 'conversation_run_active'
